export default __webpack_public_path__ + "static/media/39t.ef526ce6.jpg";